import React from 'react';
import './affiliateCard.css';
import {graphql, useStaticQuery} from "gatsby";
import {GatsbyImage, getImage} from "gatsby-plugin-image";

const AffiliateCard = ({ imagePath, title, description, buttonText, link, adsConversion }) => {
    const data = useStaticQuery(graphql`
        query {
            allImageSharp {
                nodes {
                  gatsbyImageData(layout: CONSTRAINED, height: 300, placeholder: BLURRED)
                  parent {
                    ... on ImageSharp {
                      id
                    }
                    ... on File {
                      name
                      relativePath
                    }
                  }
                }
              }
        }
    `);

    const imageNode = data.allImageSharp.nodes.find(
        node => node.parent?.relativePath === imagePath && node.gatsbyImageData
    );

    const image = imageNode ? getImage(imageNode.gatsbyImageData) : null;

    const handleButtonClick = () => {
        // Code pour suivre l'action de conversion avec Google Ads
        if (adsConversion) {
            console.log('adsConversion', adsConversion)
            // Assurez-vous que la fonction gtag est définie avant de l'appeler
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'conversion', {
                    'send_to': adsConversion
                });
            }
        }
    };


    return (
        <div className="affiliate-card affiliate-product-card">
            <div className="affiliate-product-card-container">
                {image && (
                    <div className="affiliate-product-card-image">
                        <GatsbyImage image={image} alt={title} />
                    </div>
                )}
                <div className="affiliate-product-card-title-container">
                    <h4 className="affiliate-product-card-title">
                        {title}
                    </h4>
                </div>
                <div className="affiliate-product-card-description">
                    <p>{description}</p>
                </div>
                <a href={link} className="affiliate-product-card-button affiliate-product-card-btn-accent" target="_blank" rel="noopener noreferrer" onClick={handleButtonClick}>
                    <span>{buttonText}</span>
                </a>
            </div>
        </div>
    );
};
export default AffiliateCard;
